






import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { mapActions, mapGetters } from 'vuex';
import Presentational from './presentational.vue';
import { skillList6th, skillList7th } from '../../../module/skillList';
interface Skill {
  label: string;
  initial: number;
}

@Component({
  components: { Presentational },
  computed: {
    ...mapGetters('Charactersheets', {
      gamesystem: 'getGameSystem',
      skillLists: 'getSkillList',
    }),
  },
  methods: {
    ...mapActions('Charactersheets', {
      addSkill: 'addSkill',
    }),
  },
})
export default class SkillModalContainer extends Vue {
  private get skillList() {
    return this.gamesystem === 0 ? skillList6th : skillList7th;
  }

  @Action('Charactersheets/updateSkillList')
  private updateSkillList!: (payload: Skill[]) => void;

  @Getter('Charactersheets/getGameSystem')
  private gamesystem!: number;

  public created() {
    this.updateSkillList(this.skillList);
  }
}
